export default "__VITE_ASSET__QLpHCj$u__"